/**
 * PS AF carousel affordances: passive progress bar + arrow hint.
 * Opt-in via [data-ps-af-carousel] wrapper and [data-ps-af-carousel-track] rail.
 */
(function () {
  if (window.__psAfCarouselInit) return;
  window.__psAfCarouselInit = true;

  const bound = new WeakSet();

  function isOverflowing(track) {
    return track.scrollWidth > track.clientWidth + 2;
  }

  /**
   * Update the progress bar.
   * Bar starts at 20 % and reaches 100 % when the rail is fully scrolled,
   * so there is always a visible filled portion from the start.
   */
  function updateProgress(root, track, bar) {
    const max = track.scrollWidth - track.clientWidth;
    const raw = max <= 0 ? 0 : track.scrollLeft / max;
    // 0 → 0.2, fully scrolled → 1.0
    const p = 0.2 + raw * 0.8;
    bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';

    const overflow = isOverflowing(track);
    root.dataset.overflow = overflow ? 'true' : 'false';

    const hint = root.querySelector('.ps-af-carousel__hint');
    if (hint) {
      if (overflow) {
        hint.removeAttribute('hidden');
      } else {
        hint.setAttribute('hidden', '');
      }
    }
  }

  function debounce(fn, wait) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function setupCarousel(root) {
    if (bound.has(root)) return;

    const track = root.querySelector('[data-ps-af-carousel-track]');
    const bar   = root.querySelector('.ps-af-carousel__bar');
    if (!track || !bar) return;

    bound.add(root);

    let rafId = null;
    let hasScrolled = false;

    function onScroll() {
      // Hide the arrow the moment the user touches the scroll rail
      if (!hasScrolled) {
        hasScrolled = true;
        root.dataset.scrolled = 'true';
      }

      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        updateProgress(root, track, bar);
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    const onResize = debounce(function () {
      updateProgress(root, track, bar);
    }, 150);

    window.addEventListener('resize', onResize);

    // Initialise bar at 20 % on first paint
    requestAnimationFrame(function () {
      updateProgress(root, track, bar);
    });
  }

  function init() {
    document.querySelectorAll('[data-ps-af-carousel]').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
